<dx-scroll-view>
  <div class="dx-fieldset">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="prompt.name" [showClearButton]="true" />
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Model' | translate }}</div>
      <div class="dx-field-value">
        <dx-select-box
            [items]="shownModels"
          [(value)]="selectedModel"
          [displayExpr]="displayExprFn"
          (onValueChanged)="onModelChanged($event)"
        />
          <div *ngIf="prompt.loadURLsLive">
            <span class="np-text-error">
            {{ 'Bitte wählen Sie ein eigenes Modell aus, das über eine integrierte Websuche verfügt.' | translate }}
            </span>
          </div>
      </div>
    </div>
      

      
      <div class="dx-field">
          <div class="dx-field-label">{{ 'Externe URLs laden' | translate }}</div>
          <div class="dx-field-value">
              <dx-switch [(value)]="prompt.loadURLsLive" (onValueChanged)="filterModelsAbleToSearchTheWeb()"/>
          </div>
      </div>

      <div class="dx-field">
          <div class="dx-field-label">{{ 'Dokumenten-Auslese' | translate }}</div>
          <div class="dx-field-value">
              <dx-switch [(value)]="prompt.useDocumentExtraction" (onValueChanged)="onDocumentExtractionChanged($event)"/>
          </div>
      </div>


      <div class="dx-field">
      <div class="dx-field-label">{{ 'Max. Output Länge in Zeichen' | translate }}</div>
      <div class="dx-field-value">
        <dx-number-box [(value)]="prompt.maxLenght" />
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Prompt' | translate }}</div>
      <div class="dx-field-value">
        <div class="dx-card mb-4">
          <div style="display: flex; align-items: center">
            <dx-lookup
              style="width:70%"
              [searchExpr]="['field', 'translation', 'group']"
              displayExpr="field"
              [dataSource]="dataSource"
              [grouped]="true"
              searchEnabled="true"
              [inputAttr]="{ 'aria-label': 'Grouped lookup' }"
              dropDownCentered="false"
              [(value)]="selectedTemplateItemField"
            >
              <div *dxTemplate="let data of 'item'">{{ data.translation }}  [{{data.field}}]</div>
            </dx-lookup>
              <ng-container *ngIf="isMimeField()">
                  <dx-switch
                      style="margin-left: 25px; align-self: center;"
                      hint="{{ 'Reihenfolgennummer / Sortiernummer' | translate }}"
                      [(value)]="mimePimField.useSequence"/>
                  <dx-number-box
                      class="flex-grow-1 np-highlight"
                      label="{{ (mimePimField.useSequence ? 'Reihenfolgennummer' : 'Sortiernummer') | translate }}"
                      [value]="parseInt(mimePimField.systemKey)"
                      [min]="1"
                      (onValueChanged)="onMimeNumberForMarkupChange($event)"/>
                  <dx-text-box
                      class="flex-grow-1 np-highlight"
                      label="{{ 'Filter (Beschreibung)' | translate }}"
                      [(value)]="mimeDescriptionFilter"/>
              </ng-container>
            <dx-button text="Platzhalter erstellen" (onClick)="generatePlaceholder()" />
          </div>

          <dx-text-area #promptTextArea [(value)]="prompt.prompt" autoResizeEnabled="true" />
        </div>
      </div>
    </div>
      <dx-load-indicator *ngIf="targetFieldsLoading  && prompt.usage == 'ProductLayer'" class="d-block mx-auto"></dx-load-indicator>


    <div class="dx-field">
      <div class="dx-field-value">
    <ng-container *ngIf="prompt.useDocumentExtraction">
      <span class="np-text-error"> {{'Damit Dokumente korrekt ausgelesen werden können bitte die "Bild[MIME_BLOB_URI]" verwenden!'| translate}}</span>
    </ng-container>
      </div>

      <div class="dx-field" *ngIf="loginService.hasAddonAdvancedTemplate">
        <div class="dx-field-label">{{ 'Verwendung' | translate }}</div>
        <div class="dx-field-value">
        <dx-radio-group
        [items] = promptUsageOptions
        [(value)]="prompt.usage"
        valueExpr="value"
        displayExpr="label"
        layout="horizontal"
        >
          
          
        </dx-radio-group>
        </div>
      </div>


    </div>
    
      <div  *ngIf="!targetFieldsLoading && prompt.usage == 'ProductLayer'">
      <div class="dx-field-label">{{ 'Zielfelder' | translate }}</div>

      <div class="dx-card p-3 mt-3">
          <fieldList
              [fields]="fields"
              [fieldGroups]="availableGroups"
              [(fieldListContainer)]="targetFieldsContainer"
              (onValueChanged)="onTargetFieldsChanged()"
              [style]="{ display: 'block', height: '520px', width: '100%' }"
          ></fieldList>
      </div>

      <div class="dx-field" *ngIf="featureSystemField">
          <div class="dx-field-label">{{ 'Feature-System' | translate }}</div>
          <div class="dx-field-value">
              <dx-text-box
                  [(value)]="featureSystemField.systemKey"
                  [placeholder]="'z.B. Technische Merkmale' | translate"
              />
          </div>
      </div>

      </div>
  </div>
</dx-scroll-view>
